import store from "@/store";
import router from "@/router";
import { _axios } from "@/plugins/axios";
import Global from "@/utils/Global";

const ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];
const WARNING_MS = 25 * 60 * 1000;
const LOGOUT_MS = 30 * 60 * 1000;

const idleTimer = {
  _warningTimer: null,
  _logoutTimer: null,
  _active: false,
  _boundOnActivity: null,

  install(app) {
    app.config.globalProperties.$idleTimer = this;
    this._boundOnActivity = this._onActivity.bind(this);
  },

  start() {
    if (this._active) return;
    this._active = true;
    ACTIVITY_EVENTS.forEach(e =>
      document.addEventListener(e, this._boundOnActivity, { passive: true }),
    );
    this._resetTimers();
  },

  stop() {
    if (!this._active) return;
    this._active = false;
    ACTIVITY_EVENTS.forEach(e =>
      document.removeEventListener(e, this._boundOnActivity),
    );
    this._clearTimers();
    store.commit("setIdleWarning", false);
  },

  stayLoggedIn() {
    store.commit("setIdleWarning", false);
    this._resetTimers();
  },

  _onActivity() {
    if (store.state.idle_warning) {
      store.commit("setIdleWarning", false);
    }
    this._resetTimers();
  },

  _resetTimers() {
    this._clearTimers();
    this._warningTimer = setTimeout(() => {
      if (store.state.token) {
        store.commit("setIdleWarning", true);
      }
    }, WARNING_MS);
    this._logoutTimer = setTimeout(() => {
      if (store.state.token) {
        this._performLogout();
      }
    }, LOGOUT_MS);
  },

  _clearTimers() {
    clearTimeout(this._warningTimer);
    clearTimeout(this._logoutTimer);
  },

  _performLogout() {
    this.stop();
    const doLogout = () => {
      store.commit("clear");
      _axios.defaults.headers.common["Authorization"] = "";
      router.push("/login");
    };
    _axios
      .get(Global.endpoint("/sanctum/csrf-cookie"))
      .then(() =>
        _axios
          .post(Global.endpoint("/sanctum/users/revoke"), {})
          .finally(doLogout),
      )
      .catch(doLogout);
  },
};

export default idleTimer;
